import { useFormContext } from '@calendly/form'

import { useEventType, useEventTypeContext } from 'features/event_type_provider'

import { AdhocAvailability } from './adhoc_availability'
import {
  AvailabilitySidePanel,
  AvailabilitySidePanelProvider
} from './available_hours/components/availability_side_panel'
import { ManagedAvailability } from './managed_availability'
import { MultiHostAvailability } from './multi_host_availability'
import { PersonalAvailability } from './personal_availability'
import { Range } from './range'
import { SingleUseLinkAvailability } from './single_use_link_availability'

const useAvailabilityComponent = ({ isLocked }) => {
  const { eventType, isSingleUseLink } = useEventTypeContext()
  const { isMultiHost, isMETParent, isAdhocEventType, isSolo, isUser } = eventType
  const { values: { shareOverrideAvailability } } = useFormContext()

  if (isAdhocEventType) { return AdhocAvailability }
  if (isMETParent) { return ManagedAvailability }

  if (isSingleUseLink && isSolo && isUser && !(shareOverrideAvailability?.creation && isLocked)) {
    return SingleUseLinkAvailability
  }

  if (isMultiHost) { return MultiHostAvailability }

  return PersonalAvailability
}

export const Availability = ({ isLocked, isReadOnly }) => {
  const { isAdhocEventType } = useEventType()
  const AvailabilityComponent = useAvailabilityComponent({ isLocked })

  return (
    <>
      {!isAdhocEventType && <Range isLocked={isLocked || isReadOnly} />}
      <AvailabilitySidePanelProvider>
        <AvailabilityComponent
          isLocked={isLocked}
          isReadOnly={isReadOnly}
        />
        <AvailabilitySidePanel />
      </AvailabilitySidePanelProvider>
    </>
  )
}
